import React, { Component } from "react";
import { Container, Row, Col } from "shards-react";
import UserMessagesTable from "../components/user-messages/UserMessagesTable"
import PageTitle from "../components/common/PageTitle";
import NouveauMessage from "./../components/user-messages/NouveauMessage";
import NavigationBreadcrumbs from '../components/common/NavigationBreadcrumbs'

export default class UserMessages extends Component {

  constructor(props) {
    super(props);
    this.userMessagesTable = React.createRef();
    this.onMessageSent = this.onMessageSent.bind(this);
    this.state = {
      email: ""
    }
  }

  componentDidMount() {

    console.log("UserMessages componentDidMount");
    let theUserEmail = localStorage.getItem("email");
    let theUserId = localStorage.getItem("userId");
    console.log(`theUserEmail:` + theUserEmail);
    console.log(`theUserId:` + theUserId);
    this.setState({
      email: theUserEmail
    })

  }

  onMessageSent(aData) {
    console.log("onMessageSent");

    this.userMessagesTable.current.componentDidMount();
  }

  render() {
    return (<Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle sm="8" lg="10" md="6" title="Messages" subtitle_lowercase={this.state.email} className="text-sm-left" />
        <Col sm="4" lg="2" md="6"className="text-right" >
          <NavigationBreadcrumbs  main_title="Users List" main_route="/users-list" current_title="Messages" />
        </Col>
      </Row>

      <Row>

        {/* New Draft */}
        <Col lg="3" md="12" className="mb-3" >
          <NouveauMessage title="Nouveau Message" messageSentCallback={this.onMessageSent} />
        </Col>
  { /*<Col lg="1" md="12" className="mb-3 pl-2"></Col> */ }

        <Col lg="8" md="12"> <UserMessagesTable ref={this.userMessagesTable} /> </Col>
      </Row>


    </Container>)
  }
}

